import { call, put, takeLatest } from 'redux-saga/effects'

import * as service from 'lmcv/services/customers'

import { Constants, Actions } from '.'

function * getCustomers () {
  try {
    const customers = yield call(service.getCustomers)

    yield put(Actions.getSuccess(customers))
  } catch (e) {
    yield put(Actions.getFailure(e))
  }
}

export default function * root () {
  yield takeLatest(Constants.CUSTOMERS_GET, getCustomers)
}
